/**
 * Clasificación de tipos de usuario compartida entre aplicaciones.
 *
 * Espeja la definición de backend (DEC.SharedKernel.Enums.UserTypes):
 * ambos lados deben mantenerse sincronizados.
 */

/** Usuario contribuyente titular. */
export const TAXPAYER_USER_TYPE = 'taxpayer';

/** Usuario registrado por un contribuyente para operar en su representación. */
export const TAXPAYER_DELEGATE_USER_TYPE = 'taxpayer_delegate';

/**
 * Tipos de usuario que operan bajo el contexto de un contribuyente:
 * el titular y los delegados registrados por él.
 */
export const TAXPAYER_CONTEXT_USER_TYPES: Array<string> = [
  TAXPAYER_USER_TYPE,
  TAXPAYER_DELEGATE_USER_TYPE
];
